module.exports = __webpack_public_path__ + "img/tex-free.b750234c.png";